import React, { createRef, Fragment } from 'react';
import {
    Icon, Input, Tag,
} from 'antd';

const { TextArea } = Input;

class BikeOtherUpgrades extends React.Component {
    constructor(props) {
        super(props);
        this.nodeTextarea = createRef();
        this.state = {
            textareaValue: '',
            inputId: '',
        };
    }

    addInput = () => {
        const id = Math.random().toString(16).slice(2);

        this.setState({ inputId: id });
        this.props.handleAddNewOtherUpgrades(null, id);
    }

    handleInputConfirm = (e, id) => {
        const { value } = e.target;
        this.nodeTextarea.current = null;

        this.setState({ inputId: '', textareaValue: '' });
        this.props.handleAddNewOtherUpgrades(value, id || Math.random().toString(16).slice(2));
    };

    handleTextarea = (e) => {
        e.persist();
        this.setState({ textareaValue: e.target.value });
    }

    componentDidUpdate() {
        if (this.nodeTextarea.current) {
            this.nodeTextarea.current.focus();
        }
    }

    showTextArea = (id) => (
        <TextArea
            ref={this.nodeTextarea}
            type="text"
            size="small"
            style={{ width: '100%', marginBottom: 15 }}
            onBlur={(e) => this.handleInputConfirm(e, id)}
            onPressEnter={(e) => this.handleInputConfirm(e, id)}
            value={this.state.textareaValue}
            onChange={this.handleTextarea}
        />
    )

    showTag = ({ name, customId, deleteId }) => (
        <Tag
            key={name}
            style={{
                marginBottom: 15,
                padding: '2px 24px 2px 8px',
                width: '100%',
                position: 'relative',
                whiteSpace: 'pre-wrap',
            }}
            onClick={() => this.setState({ inputId: deleteId || customId, textareaValue: name })}
        >
            {name}
            <Icon
                type="close"
                style={{ position: 'absolute', top: 6, right: 6 }}
                onClick={(e) => {
                    e.stopPropagation();
                    this.setState({ textareaValue: null, inputId: '' });
                    this.props.handleDeleteOtherUpgrades(name);
                }}
            />
        </Tag>
    )

    render() {
        const { selectedUpgrades } = this.props;
        const { inputId } = this.state;

        return (
            <div style={{ marginTop: 20 }}>
                {selectedUpgrades.map((el) => (
                    <Fragment key={el.deleteId || el.customId}>
                        {inputId === el.deleteId || inputId === el.customId ? this.showTextArea(el.deleteId || el.customId) : this.showTag(el)}
                    </Fragment>
                ))}

                {selectedUpgrades.length === 0 && (
                    <Tag onClick={this.addInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
                        <Icon type="plus" />
                        {' '}
                        New Upgrade
                    </Tag>
                )}
            </div>
        );
    }
}

export default BikeOtherUpgrades;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Lead_profile_table/BikeOtherUpgrades.js